import React from "react";
import { useTranslation } from "react-i18next";

function Top() {
  const { i18n } = useTranslation();

  const isEnglish = i18n.language === "en"; // 他言語対応なら 'startsWith' でもOK
  const iframeSrc = isEnglish
    ? "https://happy-quality.jp/en/products-and-services/stomata-scope/"
    : "https://happy-quality.jp/products-and-services/stomata-scope/";

  return (
    <div className="iframe-wrapper">
      <iframe
        src={iframeSrc}
        width="100%"
        height="100%"
        style={{ border: "none", marginTop: "-100px" }}
        title="WordPress Page"
      />
    </div>
  );
}

export default Top;
